import { FormCheckbox, FormInput, FormRadio, FormSelect } from "@/components";
import { IPrAffiliate, IPrAffiliateCreate, IPrAffiliateType } from "@/models";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
        FormSelect,
        FormCheckbox,
        FormRadio,
        FormInput,
    },
})
export default class NewPrAffiliate extends Vue {
    isOpen = true;

    public tab = "tab-1";

    public prAffiliate: IPrAffiliateCreate = {
        code: "",
        name: "",
        parentId: null,
        type: 1,
    };

    get prAffiliatesTypes(): IPrAffiliateType[] {
        return [
            {prAffiliateTypeId:1, name:"Brand Co"},
            {prAffiliateTypeId:2, name:"Market Co"},
            {prAffiliateTypeId:3, name:"Other Team"},
        ];
    }

    public selectedPrAffiliateType: IPrAffiliateType = this.prAffiliatesTypes[0];

    get prAffiliates(): IPrAffiliate[] {
        return this.$store.getters["app/prAffiliates"];
    }

    @Watch("tab")
    resetForm(): void {
        this.reset();
    }

    @Watch("isOpen")
    returnToPreviousRoute(): void {
        if (!this.isOpen) {
            this.$router.back();
        }
    }

    reset(): void {
        this.prAffiliate = {
            code: "",
            name: "",
            parentId: null,
            type: 1,
        };

        setTimeout(() => {
            const observer = this.$refs.observer as InstanceType<
                typeof ValidationObserver
            >;
            observer.reset();
        });
    }

    async submit(): Promise<void> {
        try {
            this.prAffiliate.type = this.selectedPrAffiliateType.prAffiliateTypeId;
            await this.$store.dispatch(`app/createPrAffiliate`, this.prAffiliate);
            this.$emit("success", `The PR affiliate has been successfully created`);
            this.$router.back();
        }
        catch (error) {
            this.$emit("error", error);
        }
    }

    close(): void {
        this.isOpen = false;
    }

    mounted(): void { }
}
